import axios from 'axios';
import React, { useEffect, useState } from 'react'
import secureApi from '../helpers/secureApi';
import { useNavigate } from 'react-router-dom';
import AddBtn from './AddBtn';

export default function FolderList() {

  const [folders, setFolders] = useState([]);
  const navigate = useNavigate();

  useEffect(()=>{
    axios.get(secureApi('get-folders'))
    .then(response=>{
      // console.log("response", response);
      if(response?.data?.folder){
        setFolders(response?.data?.folder);
      }
    })
    .catch(e=> console.log('get-folders error', e));
  }, []);

  const openFolder = async (id: string)=>{
    navigate('/folder/'+id);
  }

  return (
    <>
    <AddBtn name="Folder +" onClickFn={()=>navigate('/add-folder')} />
    <div className='folders'>
        {
          folders?.map((folder: {id: string, name: string})=>{
            return <div className='folder' key={folder?.id} onClick={()=> openFolder(folder?.id)}>{folder?.name}</div>
          })
        }
    </div>
    </>
  )
}
